import { PendoAgentEventType, PendoAgentProperties, SonarPendoWindow } from './@types';

declare const window: SonarPendoWindow;

export type TrackAgentEventArgs = Omit<PendoAgentProperties, 'agentId'>;

function trackEventForAgent(
	agentId: string | undefined,
	eventType: PendoAgentEventType,
	properties: TrackAgentEventArgs
): void {
	if (!agentId || !window.pendo?.trackAgent) {
		return;
	}

	try {
		window.pendo.trackAgent(eventType, {
			...properties,
			agentId
		});
	} catch {
		// Analytics must never break the app
	}
}

export function trackAgentEvent(eventType: PendoAgentEventType, properties: TrackAgentEventArgs): void {
	// eslint-disable-next-line camelcase
	trackEventForAgent(window.sonar.pendo_agent_id, eventType, properties);
}

export function trackSummaryAgentEvent(eventType: PendoAgentEventType, properties: TrackAgentEventArgs): void {
	// eslint-disable-next-line camelcase
	trackEventForAgent(window.sonar.pendo_one_shots_agent_id, eventType, properties);
}
